import { useModal } from "@landingClient/hooks/useModal";
import { AuthDialog } from "./AuthDialog";
import { NewFirmDialog } from "./NewFirmDialog";
import { ModalType } from "@landingClient/store/modalSlice";

export function ModalProvider() {
  const { activeModal, params, closeModal } = useModal();

  return (
    <>
      <AuthDialog
        isOpen={activeModal === ModalType.Auth}
        onClose={closeModal}
        dialogParams={params[ModalType.Auth]}
      />
      <NewFirmDialog
        isOpen={activeModal === ModalType.NewFirm}
        onClose={closeModal}
        dialogParams={params[ModalType.NewFirm]}
      />
    </>
  );
}
